import moment from 'moment'
import { call, put, select, delay } from 'redux-saga/effects'
import request from '@src/utility/request'
import { 
    loadTableData,
    loadTableDataFail,
    loadTableDataSuccess,
    ontTableRowDeleteSuccess,
    ontTableRowDeleteFail,
    ontTableRowAddSuccess,
    ontTableRowAddFail,
    ontTableRowUpdateSuccess,
    ontTableRowUpdateFail,
    onTableDataExportFail,
    onTableDataExportSuccess,
    onTableDataImportSuccess,
    onTableDataImportFail,
    ontTableRowAddSuccessEmpty,
    onCellLoadingSuccess,
    onCellLoadingFail,
    onTableRegisterSuccess,
    onTableRegisterFail,
    onCellLoading
} from '../../actions/table'
import { 
    selectTableCurrentPage,
    selectPerPage, 
    selectSearchQuery,
    selectDataUrl,
    selectDatDeleteUrl,
    selectDatAddUrl,
    selectDatUpdateUrl,
    selectSort,
    selectFilters,
    selectDataImportUrl,
    selectId,
    selectCellLoadingUrl,
    selectRegisterUrl
} from '../../selectors/table'
import { selectBaseUrl, selectLocale } from '../../selectors/config'
import ToastContent from '../../../components/Toast'
import { toast, Slide } from 'react-toastify'
import { selectToken } from '../../selectors/auth'


// worker Saga: will be fired on TABLE_LOAD_DATA action
export function* fetchData(params) {
    const { tableType } = params
    const ID = yield select(selectId(tableType))
    const search = yield select(selectSearchQuery(tableType))
    const filters = yield select(selectFilters(tableType))
    const sort = yield select(selectSort(tableType))
    const page = yield select(selectTableCurrentPage(tableType))
    const perPage = yield select(selectPerPage(tableType))
    const requestURL = yield select(selectBaseUrl())
    const dataURL = yield select(selectDataUrl(tableType))
    const locale = yield select(selectLocale())
    const token = yield select(selectToken())

    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"application/json",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }
    
    //eslint-disable-next-line
    let  queryParams = {
        page, 
        search,
        page_size:perPage,
        ...filters
    }
    //eslint-enable
    
    if (sort.sort) {
        queryParams['ordering'] = `${sort.dir === "desc" ? "-" : ''}${sort.sort}`
    }
    
     
    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        params: queryParams,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}${ID ? `/${ID}` : '' }`, requestOptions)
        
        if (res.data) {
            //console.log(res.data)
            yield put(loadTableDataSuccess(tableType, res.data))
        }
      
    } catch (e) {
       yield put(loadTableDataFail(tableType, [{message: e.message}]))
    }
}

// worker Saga: will be fired on INIT_TABLE_DATA_LOAD action
export function* initData(params) {
    const { tableType, filters } = params
    yield put(loadTableData(tableType))
}

// worker Saga: will be fired on TABLE_DATA_SET_PAGE action
export function* pageData(params) {
    const { tableType } = params
    yield put(loadTableData(tableType))
}

// worker Saga: will be fired on TABLE_DATA_CHANGE_PAGE_SIZE action
export function* pageSize(params) {
    const { tableType } = params
    yield put(loadTableData(tableType))
}

// worker Saga: will be fired on TABLE_DATA_SEARCH action
export function* searchData(params) {
    const { tableType } = params
    yield put(loadTableData(tableType))
}


// worker Saga: will be fired on TABLE_DATA_SORT action
export function* sortData(params) {
    const { tableType } = params
    yield put(loadTableData(tableType))
}


// worker Saga: will be fired on TABLE_LOAD_DATA action
export function* deleteRowData(params) {
    const { tableType, rowId } = params
    const requestURL = yield select(selectBaseUrl())
    const dataURL = yield select(selectDatDeleteUrl(tableType))
    const locale = yield select(selectLocale())
    const token = yield select(selectToken())

    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"application/json",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }
    
     
    const requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/${rowId}`, requestOptions)
        
        if (res.data.status === "success") yield put(ontTableRowDeleteSuccess(tableType, res?.data?.id))
        else {
            yield put(ontTableRowDeleteFail(tableType, [{message: res.data.message}]))

            toast.error(
                <ToastContent type="error" title="Ooops!" body={res.data.message} />,
                { transition: Slide, hideProgressBar: true }
                )
        }
      
    } catch (e) {
       yield put(ontTableRowDeleteFail(tableType, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={res.data} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}

// worker Saga: will be fired on TABLE_ROW_ADD action
export function* addData(params) {
    const { tableType, data, callback } = params
    const requestURL = yield select(selectBaseUrl())
    const dataURL = yield select(selectDatAddUrl(tableType))
    const locale = yield select(selectLocale())
    const token = yield select(selectToken())

    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }

    try {
    
    /*eslint-disable */
    let formdata = new FormData()
    for (let k in data) {
        console.log('here')
       
        if (typeof data[k] !=="undefined" && data[k].toString.call(data[k]).slice(8, -1) === 'FileList'){
            for(const i in data[k]){
                if ( data[k][i].type)  formdata.append(k, data[k][i], data[k][i].name)
            }
        } 
        else if(typeof data[k] !=="undefined" && data[k].length && data[k].map){
            data[k].map((item) => {
                formdata.append(k, item)
            })
        }
        else if(typeof data[k] !=="undefined") formdata.append(k, data[k])
    
    }
    /*eslint-enable */

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        data:formdata,
        mode:'cors',
        credentials:'include'
    }
        
        const res = yield call(request, `${requestURL}${dataURL}/`, requestOptions)

        if (res.data?.status === "success") {
            toast.success(
                <ToastContent type="error" title="Hurray!" body={res.data?.message} />,
                { transition: Slide, hideProgressBar: true }
            )
            yield put(ontTableRowAddSuccessEmpty(tableType))
            yield callback(true)
        }
        
        if (res.data?.id) {
            
            yield put(ontTableRowAddSuccess(tableType, res.data))
            yield callback(true)
        } else { 

            toast.error(
                <ToastContent type="error" title="Oops!" body={res.data?.message} />,
                { transition: Slide, hideProgressBar: true }
            )

            yield put(ontTableRowAddFail(tableType, res.data))
            yield callback(false)
        }
        
      
    } catch (e) {
       yield put(ontTableRowAddFail(tableType, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}


// worker Saga: will be fired on TABLE_ROW_UPDATE action
export function* updateData(params) {
    const { tableType, id, data } = params
   
    const requestURL = yield select(selectBaseUrl())
    const dataURL = yield select(selectDatUpdateUrl(tableType))
    const locale = yield select(selectLocale())
    const token = yield select(selectToken())

    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }

    /*eslint-disable */
    let formdata = new FormData()
    
    
    for (let k in data) {
        
        if (typeof data[k] !=="undefined" && data[k].toString.call(data[k]).slice(8, -1) === 'FileList'){
            for(const i in data[k]){
                if ( data[k][i].type)  formdata.append(k, data[k][i], data[k][i].name)
            }
        } 
        else if(typeof data[k] !=="undefined" && typeof data[k] !=="undefined" && data[k].length && data[k].map){
            data[k].map((item) => {
                formdata.append(k, item)
            })
        }
        else if(typeof data[k] !=="undefined") formdata.append(k, data[k])
    
    }
    /*eslint-enable */
     
    const requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        data:formdata,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/${id}`, requestOptions)
        
        if (res.data?.id) {
            
            yield put(ontTableRowUpdateSuccess(tableType, id, res.data))
        } else  {
            yield put(ontTableRowUpdateFail(tableType, id, res.data))

            toast.error(
                <ToastContent type="error" title="Ooops!" body={res.data} />,
                { transition: Slide, hideProgressBar: true }
            )
        }
        
      
    } catch (e) {
       yield put(ontTableRowUpdateFail(tableType, id, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}


function exportCsvData(response, tableType) {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${tableType}${moment().format()}.csv`) //or any other extension
    document.body.appendChild(link)
    link.click()
}

// worker Saga: will be fired on TABLE_EXPORT_FAIL action
export function* exportData(params) {
    const { tableType } = params
    const search = yield select(selectSearchQuery(tableType))
    const filters = yield select(selectFilters(tableType))
    const sort = yield select(selectSort(tableType))
    const requestURL = yield select(selectBaseUrl())
    const dataURL = yield select(selectDataUrl(tableType))
    const locale = yield select(selectLocale())
    const token = yield select(selectToken())

    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"application/json",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }
    
    //eslint-disable-next-line
    let  queryParams = {
        search,
        ...filters
    }
    //eslint-enable
    
    if (sort.sort) {
        queryParams['ordering'] = `${sort.dir === "desc" ? "-" : ''}${sort.sort}`
    }
    
     
    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        params: queryParams,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}Export/`, requestOptions)
        
        if (res.data) {
            yield put(onTableDataExportSuccess(tableType))
            exportCsvData(res, tableType)
        }
      
    } catch (e) {
       yield put(onTableDataExportFail(tableType))
    }
}

// worker Saga: will be fired on TABLE_IMPORT action
export function* importData(params) {
    const { tableType, data } = params
    const requestURL = yield select(selectBaseUrl())
    const importUrl = yield select(selectDataImportUrl(tableType))
    const locale = yield select(selectLocale())
    const token = yield select(selectToken())

    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }

    try {
    
    /*eslint-disable */
    let formdata = new FormData()
    for (let k in data) {
        console.log(data[k])
       
        if (typeof data[k] !=="undefined" && data[k].toString.call(data[k]).slice(8, -1) === 'FileList'){
            
            if ( data[k][0].type)  formdata.append(k, data[k][0], data[k][0].name)
            
        } 
    
    }
    /*eslint-enable */

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        data:formdata,
        mode:'cors',
        credentials:'include'
    }
        
        const res = yield call(request, `${requestURL}${importUrl}/`, requestOptions)
        
        if (res.data?.status === "successfully imported") {
            
            yield put(onTableDataImportSuccess(tableType))
            yield put(loadTableData(tableType))

            toast.error(
                <ToastContent type="success" title="Hurray!" body={res.data?.status} />,
                { transition: Slide, hideProgressBar: true }
            )

        } else yield put(onTableDataImportFail(tableType, res.data))
        
      
    } catch (e) {
       yield put(onTableDataImportFail(tableType, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}

// worker Saga: will be fired on CELL_LOADING action
export function* cellLoading(params) {
    const { tableType, data, id, rowIndex } = params
    const requestURL = yield select(selectBaseUrl())
    const dataURL = yield select(selectCellLoadingUrl(tableType))
    const token = yield select(selectToken())

    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
        Authorization: `Token ${token}`
    }

    try {

    /*eslint-disable */
    let formdata = new FormData()
    /*eslint-enable */

    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        data,
        mode:'cors',
        credentials:'include'
    }

    yield delay(rowIndex * 900)

    const res = yield call(request, `${requestURL}${dataURL}/${id}`, requestOptions)
    
    if (res?.data?.status === true && res?.data?.data?.id) yield put(onCellLoadingSuccess(tableType, id, res?.data?.data))
    else if (res?.data?.status === false) {
        yield put(onCellLoadingFail(tableType, id, { errors: { message: 'failed to load data' } }))
        toast.error(
            <ToastContent
                type="error"
                title={`OOOPS!`}
                body={'Failed to load data'}
            />,
            { transition: Slide, hideProgressBar: true, autoClose: 2000 }
        )
    } else yield put(onCellLoadingFail(tableType, id, { errors: { message: 'failed to load data' } }))
    
    } catch (e) {
       yield put(onCellLoadingFail(tableType, id, [{message: 'Failed to load data'}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}

// worker Saga: will be fired on CELL_LOADING action
export function* registrationData(params) {
    const { tableType, data, id } = params
    const requestURL = yield select(selectBaseUrl())
    const dataURL = yield select(selectRegisterUrl(tableType))
    const token = yield select(selectToken())

    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
       // "User-Agent": "Web App",
        Authorization: `Token ${token}`,
       // Origin : "*"
    }

    try {

    /*eslint-disable */
    let formdata = new FormData()

    for (let k in data) {
        console.log('here')
       
        if (typeof data[k] !=="undefined" && data[k].toString.call(data[k]).slice(8, -1) === 'FileList'){
            for(const i in data[k]){
                if ( data[k][i].type)  formdata.append(k, data[k][i], data[k][i].name)
            }
        } 
        else if(typeof data[k] !=="undefined" && data[k].length && data[k].map){
            data[k].map((item) => {
                formdata.append(k, item)
            })
        }
        else if(typeof data[k] !=="undefined") formdata.append(k, data[k])
    
    }
    /*eslint-enable */

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        data: formdata,
        mode:'cors',
        credentials:'include'
    }

    const res = yield call(request, `${requestURL}${dataURL}/${id}`, requestOptions)
    
    if (res?.data?.status === true) {
        yield put(onTableRegisterSuccess(tableType, id))
        yield put(onCellLoading(tableType, id, {}))
        
    } else if (res?.data?.status === false) {
        yield put(onTableRegisterFail(tableType, id, { errors: { message: 'failed to register' } }))
        toast.error(
            <ToastContent
                type="error"
                title={`OOOPS!`}
                body={'Failed to register'}
            />,
            { transition: Slide, hideProgressBar: true, autoClose: 2000 }
        )
    } else yield put(onTableRegisterFail(tableType, id, { errors: { message: 'failed to register' } }))
    
    } catch (e) {
       yield put(onTableRegisterFail(tableType, id, [{message: 'Failed to register'}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}